import styled from "styled-components";
import { Heading } from "@pepdirect/v3/ui/Heading";
import { Spinner } from "@pepdirect/v3/ui/Spinner";

export const StyledAddButton = styled.div`
  margin-bottom: 40px;
  span {
    margin-left: 8px;
  }
`;

export const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
`;

export const StyledNewPaymentForm = styled.div`
  margin-bottom: 40px;
`;

export const StyledSavedPaymentMethods = styled.div`
  margin: 16px 0;
`;

export const StyledSpinner = styled(Spinner)`
  margin-top: 60px;
`;
